import React, { useState } from 'react';

interface Props {
  initial?: string;   // pre-fill name when editing
  onSave: (name: string) => void;
  onClose: () => void;
  title?: string;
}

export const CategoryModal: React.FC<Props> = ({ initial = '', onSave, onClose, title = 'New Category' }) => {
  const [name, setName] = useState(initial);

  const handleSave = () => {
    const trimmed = name.trim();
    if (!trimmed) return;
    onSave(trimmed);
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4" style={{ backgroundColor: 'rgba(0,0,0,0.7)' }}>
      <div className="bg-gray-900 border border-white/10 rounded-2xl w-full max-w-sm p-6 space-y-5">
        <h2 className="text-lg font-bold text-white">{title}</h2>
        <div>
          <label className="block text-xs font-bold text-gray-400 uppercase tracking-widest mb-2">Category Name</label>
          <input
            autoFocus
            className="w-full bg-white/5 border border-white/10 rounded-xl px-4 py-3 text-white placeholder-gray-600 focus:outline-none focus:border-indigo-500"
            value={name}
            onChange={(e) => setName(e.target.value)}
            onKeyDown={(e) => e.key === 'Enter' && handleSave()}
            placeholder="e.g. Specials"
          />
        </div>
        <div className="flex gap-3">
          <button onClick={onClose} className="flex-1 py-3 rounded-xl border border-white/10 text-gray-400 hover:text-white transition-colors font-semibold">
            Cancel
          </button>
          <button
            onClick={handleSave}
            disabled={!name.trim()}
            className="flex-1 py-3 rounded-xl bg-indigo-600 hover:bg-indigo-500 disabled:opacity-40 text-white font-bold transition-colors"
          >
            Save
          </button>
        </div>
      </div>
    </div>
  );
};
